// eslint-disable-next-line import/no-webpack-loader-syntax
import Worker from "comlink-loader!./LLDB.worker";

export default Worker;
